<template>
  <v-dialog
    v-model="getModalCadastroPosVenda"
    persistent
    max-width="720px"
    transition="dialog-transition"
  >
    <v-card>
      <v-card-title>Adicionar Pós-Venda</v-card-title>
      <v-card-text>
        <v-form ref="formCadastroPosVenda" class="px-3 pt-3">
          <v-layout row wrap>
            <v-flex xs12 md12>
              <v-text-field
                label="Próximo contato em:"
                outlined
                dense
                v-model="getPosVenda.proximo_contato"
                type="date"
                :rules="rules.proximo_contato"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn color="default" outlined @click="setModalCadastroPosVenda(false)"
          >Voltar</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn color="success" outlined @click="modalConfirmacaoCadastro = true"
          >Salvar</v-btn
        >
      </v-card-actions>
    </v-card>
    <v-dialog
      v-model="modalConfirmacaoCadastro"
      persistent
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title>Confirmação</v-card-title>
        <v-card-text>
          <h3 align="center">Tem certeza que deseja salvar?</h3>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="default"
            outlined
            @click="modalConfirmacaoCadastro = false"
            :loading="$store.getters.getOverlay"
          >
            Voltar</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="success" :loading="$store.getters.getOverlay" outlined @click="salvar()"> Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      modalConfirmacaoCadastro: false,
      rules: {
        proximo_contato: [(v) => !!v || "Campo obrigatório."],
      },
    };
  },
  computed: {
    ...mapGetters(["getModalCadastroPosVenda", "getPosVenda", "getVenda"]),
  },
  methods: {
    ...mapActions([
      "cadastrarPosVenda",
      "setModalCadastroPosVenda",
      "setModalExcluirPosVenda",
      "salvarPosVenda",
      "atualizarPosVenda",
    ]),
    salvar() {
      this.modalConfirmacaoCadastro = false;
      if (this.$refs.formCadastroPosVenda.validate() === false) {
        return;
      }
      this.getPosVenda.venda_id = this.getVenda.id;
      this.salvarPosVenda(this.getPosVenda);
    },
  },
  created() {},
};
</script>